import * as React from "react";
const SvgCalculationOneBar = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "40px", viewBox: "0 -960 960 960", width: "40px", fill: "#FFFFFF", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M200-160v-240h106.67v240H200Z" }));
export default SvgCalculationOneBar;
